(function () {
	if (window.physicalStoresStack) return;
	window.physicalStoresStack = true;

	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	var frame = 0;

	function updateList(list) {
		var items = list.querySelectorAll(':scope > li');
		if (items.length < 2) return;

		var stickyTop = parseFloat(window.getComputedStyle(items[0]).top) || 0;

		items.forEach(function (item, index) {
			item.style.setProperty('--store-stack', String(index + 1));
			var card = item.querySelector('.physical-stores__card');
			if (!card) return;

			var next = items[index + 1];
			if (!next) {
				card.style.setProperty('--store-scale', '1');
				return;
			}

			var itemRect = item.getBoundingClientRect();
			var nextRect = next.getBoundingClientRect();
			var coverStart = itemRect.top + itemRect.height;
			var distance = coverStart - stickyTop;
			var progress = distance > 0 ? (coverStart - nextRect.top) / distance : 0;
			progress = Math.min(1, Math.max(0, progress));
			card.style.setProperty('--store-scale', (1 - progress * 0.08).toFixed(3));
		});
	}

	function update() {
		if (reduceMotion.matches) return;
		document.querySelectorAll('[data-store-stack]').forEach(updateList);
	}

	function requestUpdate() {
		cancelAnimationFrame(frame);
		frame = requestAnimationFrame(update);
	}

	update();
	window.addEventListener('scroll', requestUpdate, { passive: true });
	window.addEventListener('resize', requestUpdate);
	document.addEventListener('shopify:section:load', requestUpdate);
})();
